import { Component } from '@angular/core';
import { APPCONFIG } from '../../config';
import { Router }  from '@angular/router';
import { ErrorHandler } from '../../shared/services/error-handler.service';
import { SessionHandler } from '../../shared/services/session-handler.service';
import { HttpService } from '../../shared/services/http.service';
import { CommonService } from '../../shared/services/common.service';
import { LayoutService } from '../../layout/layout.service';

@Component({
    selector: 'my-app-header',
    styles: [],
    template: require('./header.component.html')
})

export class AppHeaderComponent {
    AppConfig: any;
    public userDetails: any;

    constructor(private router: Router,public httpService : HttpService,public errorHandler : ErrorHandler,
                public layoutService : LayoutService, public sessionHandler : SessionHandler, public commonService:CommonService){

        this.userDetails={image:''};

        try {
            if(this.sessionHandler.getItem("userDetails") != null) {
                this.userDetails = JSON.parse(this.sessionHandler.getItem("userDetails"));
                if(!this.userDetails) throw "Invalid user details.";
            }else {
                this.router.navigate(['/login']);
            }
        }catch(err){
            this.router.navigate(['/login']);
        }
    }

    logout() {
        //this.commonService.setLoginRedirectUrl(window.location.hash);
        this.sessionHandler.removeItem('loginData');
        this.sessionHandler.removeItem('timestamp');
        this.sessionHandler.removeItem('userDetails');
        this.router.navigate(['/login']);
    }

    public saveResponse(res){
        if(res.errorStatus == 'Fail') {
            this.httpService.onEnd();
            alert('Not able to Logout Please Try Again');
        } else {
            this.httpService.onEnd();
            //this.commonService.setLoginRedirectUrl('');
            this.sessionHandler.clearAllItems();
            this.router.navigate(['/login']);
        }
    }

    toggleCollapsedNav() {
        this.AppConfig.navCollapsed = !this.AppConfig.navCollapsed;
    }

    ngOnInit() {
        this.AppConfig = APPCONFIG;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/header/header.component.ts